import { c as a } from "./ghl-ui.es384.js";
import r from "./ghl-ui.es1158.js";
const {
  cubicBezierEaseIn: i,
  cubicBezierEaseOut: s
} = r;
function $({
  transformOrigin: c = "inherit",
  duration: e = ".2s",
  enterScale: o = ".9",
  originalTransform: n = "",
  originalTransition: t = ""
} = {}) {
  return [a("&.fade-in-scale-up-transition-leave-active", {
    transformOrigin: c,
    transition: `opacity ${e} ${i}, transform ${e} ${i} ${t && "," + t}`
  }), a("&.fade-in-scale-up-transition-enter-active", {
    transformOrigin: c,
    transition: `opacity ${e} ${s}, transform ${e} ${s} ${t && "," + t}`
  }), a("&.fade-in-scale-up-transition-enter-from, &.fade-in-scale-up-transition-leave-to", {
    opacity: 0,
    transform: `${n} scale(${o})`
  }), a("&.fade-in-scale-up-transition-leave-from, &.fade-in-scale-up-transition-enter-to", {
    opacity: 1,
    transform: `${n} scale(1)`
  })];
}
export {
  $ as fadeInScaleUpTransition
};
